const ITEMS = [
  "Filter Coffee",
  "தரமான காபி",
  "Premium Tea",
  "Assam Tea",
  "நினைவுகளின் சுவை",
  "Instant Coffee",
  "The Modern Village",
];

const Row = ({ ariaHidden = false }) => (
  <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-2xl italic text-cream/35 md:px-12 md:text-3xl">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rounded-full bg-gold/50" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    data-testid="brand-marquee"
    className="overflow-hidden border-y border-cream/10 bg-coffee py-6"
  >
    <div className="marquee-track">
      <Row />
      <Row ariaHidden />
    </div>
  </div>
);

export default Marquee;
